import { combineReducers } from "@reduxjs/toolkit";
import appReducer from "./app/store.js";
import domReducer from "./dom/store.js";
import stationsReducer from "./stations/store.js";
import bmwRentObjectReducer from "./rent_objects/store.js";
import bmwRcReducer from "./rent_contracts/store.js";
import historyReducer from "./history/store.js";
import windowReducer from "./window/store.js";
import bmwUserReducer from "./user/store.js";

import {
  sidebarPanelReducer,
  configReducer,
  errorsReducer,
  timeReducer,
  l10nReducer,
  cmsReducer,
  sharedStationReducer,
  userReducer,
  rentObjectsReducer,
  rentContractsReducer
} from "@awe-web/shared/lib";


export default combineReducers({
  config: configReducer,
  errors: errorsReducer,
  burgerMenu: sidebarPanelReducer,
  time: timeReducer,
  l10n: l10nReducer,
  cmsPages: cmsReducer,
  shared_stations: sharedStationReducer,
  rent_objects: rentObjectsReducer,
  rent_contracts: rentContractsReducer,
  user: userReducer,

  app: appReducer,
  dom: domReducer,
  station: stationsReducer,
  bmw_rent_objects: bmwRentObjectReducer,
  bmw_rent_contracts: bmwRcReducer,
  bmw_user: bmwUserReducer,
  history: historyReducer,
  window: windowReducer
}
);
